import * as React from 'react';

function LoginLink() {
  return <></>;
}

export default LoginLink;
